__webpack_require__.p = "/dg-pc/_next/";